import type { ReactNode } from 'react';
import { Icon } from '../icons/Icon.js';
import type { IconName } from '../icons/registry.js';

type Props = {
  icon?: IconName;
  title: string;
  sub?: ReactNode;
  variant?: 'dashed' | 'plain';
};

export function EmptyState({ icon = 'search', title, sub, variant = 'dashed' }: Props) {
  return (
    <div className={'empty' + (variant === 'plain' ? ' empty-plain' : '')}>
      <div className="empty-icon"><Icon name={icon} size={22} /></div>
      <div className="empty-title">{title}</div>
      {sub && <div className="empty-sub">{sub}</div>}
    </div>
  );
}
